export default __webpack_public_path__ + "static/media/cloudy.2475692a.svg";